"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Barcode_Scanner = void 0;
var react_1 = __importStar(require("react"));
var quagga2_1 = __importDefault(require("@ericblade/quagga2"));
var styled_components_1 = __importDefault(require("styled-components"));
var api_1 = require("../../api");
var api_2 = require("../../api");
var last_lookup_time = performance.now();
function Barcode_Scanner(props) {
    var _a = (0, react_1.useState)(null), scanned_food = _a[0], set_scanned_food = _a[1];
    // const [last_lookup_time, set_last_lookup_time] = useState(performance.now());
    (0, react_1.useEffect)(function () {
        // console.log("barcode scanner useEffect!")
        var config = {
            // debug: true,
            locate: false,
            inputStream: {
                name: "Live",
                type: "LiveStream",
                target: document.querySelector("#viewport"),
                // constraints: {
                //     width: 200,
                //     height: 200
                // }
            },
            decoder: {
                readers: ["upc_reader"],
                // debug: {
                //     drawScanline: true,
                //     drawBoundingBox: true,
                //     showFrequency: true,
                //     showPattern: true
                // }
            },
            locator: {
                halfSample: true,
                patchSize: "small", // x-small, small, medium, large, x-large
                // debug: {
                //   showCanvas: false,
                //   showPatches: false,
                //   showFoundPatches: false,
                //   showSkeleton: false,
                //   showLabels: false,
                //   showPatchLabels: false,
                //   showRemainingPatchLabels: false,
                //   boxFromPatches: {
                //     showTransformed: false,
                //     showTransformedBox: false,
                //     showBB: false
                //   }
                // }
            }
        };
        function get_nutrient(food, index) {
            var value = food.full_nutrients.find(function (a) { return a.attr_id == index; });
            if (value == undefined)
                return 0;
            return value.value;
        }
        // function convert_nutritionix_food(food) {
        //     // console.log("nutritionix_food: ", nutritionix_food);
        //     const new_food: Food = {
        //         food_name: food.food_name,
        //         calories_per_serving: get_nutrient(food, 208),
        //         servings: 1,
        //         serving_qty: food.serving_qty,
        //         // serving_size: food.serving_unit,
        //         carbs: get_nutrient(food, 205),
        //         protein: get_nutrient(food, 203),
        //         total_fat: get_nutrient(food, 204),
        //         trans_fat: get_nutrient(food, 605),
        //         sat_fat: get_nutrient(food, 606),
        //         poly_fat: get_nutrient(food, 646),
        //         mono_fat: get_nutrient(food, 645),
        //         cholesterol: get_nutrient(food, 601),
        //         sodium: get_nutrient(food, 307),
        //         potassium: get_nutrient(food, 306),
        //         fiber: get_nutrient(food, 291),
        //         sugar: get_nutrient(food, 269),
        //         vitamin_a: get_nutrient(food, 318),
        //         vitamin_c: get_nutrient(food, 401),
        //         calcium: get_nutrient(food, 301),
        //         iron: get_nutrient(food, 303),
        //         meal:  props.meal,
        //         serving_unit: food.serving_unit,
        //         alt_measures: []
        //     }
        //     // console.log(food);
        //     return new_food;
        // }
        quagga2_1.default.init(config, function (err) {
            if (err) {
                console.log(err);
                return;
            }
            //   console.log("Initialization finished. Ready to start");
            quagga2_1.default.start();
        });
        quagga2_1.default.onDetected(function (detected) {
            return __awaiter(this, void 0, void 0, function () {
                var code, result, converted_food;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log(performance.now() - last_lookup_time);
                            if (performance.now() - last_lookup_time < 1000) {
                                return [2 /*return*/];
                            }
                            // set_last_lookup_time(performance.now());
                            last_lookup_time = performance.now();
                            code = detected.codeResult.code;
                            return [4 /*yield*/, (0, api_1.search_upc)(code)];
                        case 1:
                            result = _a.sent();
                            console.log("result: ", result);
                            converted_food = (0, api_2.convert_nutritionix_food)(result, props.meal);
                            console.log('converted_food: ', converted_food);
                            props.set_food(converted_food);
                            quagga2_1.default.stop();
                            return [2 /*return*/];
                    }
                });
            });
        });
        quagga2_1.default.onProcessed(function (result) {
            // console.log(result)
            var drawingCtx = quagga2_1.default.canvas.ctx.overlay, drawingCanvas = quagga2_1.default.canvas.dom.overlay;
            if (result) {
                // drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                if (result.boxes) {
                    drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                    result.boxes.filter(function (box) {
                        return box !== result.box;
                    }).forEach(function (box) {
                        quagga2_1.default.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, { color: "green", lineWidth: 2 });
                    });
                }
                if (result.box) {
                    quagga2_1.default.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: "blue", lineWidth: 2 });
                }
                if (result.codeResult && result.codeResult.code) {
                    quagga2_1.default.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: 'red', lineWidth: 3 });
                }
            }
        });
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Viewport, { id: "viewport" }),
        scanned_food &&
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", null, scanned_food.food_name),
                react_1.default.createElement("div", null, scanned_food.nix_brand_name),
                react_1.default.createElement("image", { href: scanned_food.photo.thumb }))));
}
exports.Barcode_Scanner = Barcode_Scanner;
var Viewport = styled_components_1.default.div.withConfig({ displayName: "Barcode_Scanner.tsx-Viewport", componentId: "-s3ogdi" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    // background: black;\n    position: relative;\n    height: 100%;\n    width: 100%;\n\n    & canvas {\n        position: absolute;\n        top: 0px;\n        left: 0px;\n        height: 75%;\n        width: 75%;\n        // border: 3px solid green;\n    }\n\n    & video {\n        position: absolute;\n        top: 0px;\n        left: 0px;\n        height: 75%;\n        width: 75%;\n        // border: 3px solid green;\n        // z-index: 0;\n    }\n"], ["\n    // background: black;\n    position: relative;\n    height: 100%;\n    width: 100%;\n\n    & canvas {\n        position: absolute;\n        top: 0px;\n        left: 0px;\n        height: 75%;\n        width: 75%;\n        // border: 3px solid green;\n    }\n\n    & video {\n        position: absolute;\n        top: 0px;\n        left: 0px;\n        height: 75%;\n        width: 75%;\n        // border: 3px solid green;\n        // z-index: 0;\n    }\n"])));
var templateObject_1;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFyY29kZV9TY2FubmVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiQmFyY29kZV9TY2FubmVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSw2Q0FBc0U7QUFDdEUsK0RBQWtFO0FBQ2xFLHdFQUFzQztBQUN0QyxpQ0FBdUM7QUFFdkMsaUNBQW9EO0FBRXBELElBQUksZ0JBQWdCLEdBQUcsV0FBVyxDQUFDLEdBQUcsRUFBRSxDQUFDO0FBRXpDLFNBQWdCLGVBQWUsQ0FBQyxLQUFLO0lBQzNCLElBQUEsS0FBbUMsSUFBQSxnQkFBUSxFQUFDLElBQUksQ0FBQyxFQUFoRCxZQUFZLFFBQUEsRUFBRSxnQkFBZ0IsUUFBa0IsQ0FBQztJQUN4RCxnRkFBZ0Y7SUFFaEYsSUFBQSxpQkFBUyxFQUFDO1FBQ04sNENBQTRDO1FBRTVDLElBQU0sTUFBTSxHQUF5QjtZQUNqQyxlQUFlO1lBQ2YsTUFBTSxFQUFFLEtBQUs7WUFDYixXQUFXLEVBQUU7Z0JBQ1QsSUFBSSxFQUFFLE1BQU07Z0JBQ1osSUFBSSxFQUFFLFlBQVk7Z0JBQ2xCLE1BQU0sRUFBRSxRQUFRLENBQUMsYUFBYSxDQUFDLFdBQVcsQ0FBQztnQkFDM0MsaUJBQWlCO2dCQUNqQixrQkFBa0I7Z0JBQ2xCLGtCQUFrQjtnQkFDbEIsSUFBSTthQUNQO1lBQ0QsT0FBTyxFQUFFO2dCQUNMLE9BQU8sRUFBRSxDQUFDLFlBQVksQ0FBQztnQkFDdkIsV0FBVztnQkFDWCwwQkFBMEI7Z0JBQzFCLDZCQUE2QjtnQkFDN0IsMkJBQTJCO2dCQUMzQix3QkFBd0I7Z0JBQ3hCLElBQUk7YUFDUDtZQUNELE9BQU8sRUFBRTtnQkFDTCxVQUFVLEVBQUUsSUFBSTtnQkFDaEIsU0FBUyxFQUFFLE9BQU8sRUFBRSx5Q0FBeUM7Z0JBQzdELFdBQVc7Z0JBQ1gsdUJBQXVCO2dCQUN2Qix3QkFBd0I7Z0JBQ3hCLDZCQUE2QjtnQkFDN0IseUJBQXlCO2dCQUN6Qix1QkFBdUI7Z0JBQ3ZCLDRCQUE0QjtnQkFDNUIscUNBQXFDO2dCQUNyQyxzQkFBc0I7Z0JBQ3RCLDhCQUE4QjtnQkFDOUIsaUNBQWlDO2dCQUNqQyxvQkFBb0I7Z0JBQ3BCLE1BQU07Z0JBQ04sSUFBSTthQUNMO1NBQ04sQ0FBQztRQUVGLFNBQVMsWUFBWSxDQUFDLElBQUksRUFBRSxLQUFLO1lBQzdCLElBQU0sS0FBSyxHQUFHLElBQUksQ0FBQyxjQUFjLENBQUMsSUFBSSxDQUFDLFVBQUEsQ0FBQyxJQUFJLE9BQUEsQ0FBQyxDQUFDLE9BQU8sSUFBSSxLQUFLLEVBQWxCLENBQWtCLENBQUMsQ0FBQztZQUNoRSxJQUFJLEtBQUssSUFBSSxTQUFTO2dCQUFFLE9BQU8sQ0FBQyxDQUFDO1lBQ2pDLE9BQU8sS0FBSyxDQUFDLEtBQUssQ0FBQztRQUN2QixDQUFDO1FBRUQsNENBQTRDO1FBQzVDLDhEQUE4RDtRQUU5RCwrQkFBK0I7UUFDL0IscUNBQXFDO1FBQ3JDLHlEQUF5RDtRQUN6RCx1QkFBdUI7UUFDdkIseUNBQXlDO1FBQ3pDLDhDQUE4QztRQUM5QywwQ0FBMEM7UUFDMUMsNENBQTRDO1FBQzVDLDhDQUE4QztRQUM5Qyw4Q0FBOEM7UUFDOUMsNENBQTRDO1FBQzVDLDZDQUE2QztRQUM3Qyw2Q0FBNkM7UUFDN0MsZ0RBQWdEO1FBQ2hELDJDQUEyQztRQUMzQyw4Q0FBOEM7UUFDOUMsMENBQTBDO1FBQzFDLDBDQUEwQztRQUMxQyw4Q0FBOEM7UUFDOUMsOENBQThDO1FBQzlDLDRDQUE0QztRQUM1Qyx5Q0FBeUM7UUFDekMsNkJBQTZCO1FBQzdCLDJDQUEyQztRQUMzQywyQkFBMkI7UUFDM0IsUUFBUTtRQUVSLDRCQUE0QjtRQUM1Qix1QkFBdUI7UUFDdkIsSUFBSTtRQUVKLGlCQUFNLENBQUMsSUFBSSxDQUNQLE1BQU0sRUFDTixVQUFVLEdBQUc7WUFDWCxJQUFJLEdBQUcsRUFBRTtnQkFDUCxPQUFPLENBQUMsR0FBRyxDQUFDLEdBQUcsQ0FBQyxDQUFDO2dCQUNqQixPQUFPO2FBQ1I7WUFDSCw0REFBNEQ7WUFDMUQsaUJBQU0sQ0FBQyxLQUFLLEVBQUUsQ0FBQztRQUNqQixDQUFDLENBQ0YsQ0FBQztRQUVGLGlCQUFNLENBQUMsVUFBVSxDQUFDLFVBQWdCLFFBQVE7Ozs7Ozs0QkFDeEMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxXQUFXLENBQUMsR0FBRyxFQUFFLEdBQUcsZ0JBQWdCLENBQUMsQ0FBQTs0QkFDakQsSUFBSSxXQUFXLENBQUMsR0FBRyxFQUFFLEdBQUcsZ0JBQWdCLEdBQUcsSUFBSSxFQUFFO2dDQUM3QyxzQkFBTzs2QkFDVjs0QkFFRCwyQ0FBMkM7NEJBQzNDLGdCQUFnQixHQUFHLFdBQVcsQ0FBQyxHQUFHLEVBQUUsQ0FBQzs0QkFDakMsSUFBSSxHQUFHLFFBQVEsQ0FBQyxVQUFVLENBQUMsSUFBSSxDQUFDOzRCQUtyQixxQkFBTSxJQUFBLGdCQUFVLEVBQUMsSUFBSSxDQUFDLEVBQUE7OzRCQUEvQixNQUFNLEdBQUcsU0FBc0I7NEJBQ3JDLE9BQU8sQ0FBQyxHQUFHLENBQUMsVUFBVSxFQUFFLE1BQU0sQ0FBQyxDQUFDOzRCQUUxQixjQUFjLEdBQUcsSUFBQSw4QkFBd0IsRUFBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLElBQUksQ0FBQyxDQUFDOzRCQUNwRSxPQUFPLENBQUMsR0FBRyxDQUFDLGtCQUFrQixFQUFFLGNBQWMsQ0FBQyxDQUFDOzRCQUNoRCxLQUFLLENBQUMsUUFBUSxDQUFDLGNBQWMsQ0FBQyxDQUFDOzRCQUUvQixpQkFBTSxDQUFDLElBQUksRUFBRSxDQUFDOzs7OztTQVdmLENBQUMsQ0FBQztRQUVILGlCQUFNLENBQUMsV0FBVyxDQUFDLFVBQVUsTUFBTTtZQUNqQyxzQkFBc0I7WUFFdEIsSUFBSSxVQUFVLEdBQUcsaUJBQU0sQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLE9BQU8sRUFDMUMsYUFBYSxHQUFHLGlCQUFNLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxPQUFPLENBQUM7WUFFMUMsSUFBSSxNQUFNLEVBQUU7Z0JBQ1IsNkhBQTZIO2dCQUN6SCxJQUFJLE1BQU0sQ0FBQyxLQUFLLEVBQUU7b0JBQ2QsVUFBVSxDQUFDLFNBQVMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxFQUFFLFFBQVEsQ0FBQyxhQUFhLENBQUMsWUFBWSxDQUFDLE9BQU8sQ0FBQyxDQUFDLEVBQUUsUUFBUSxDQUFDLGFBQWEsQ0FBQyxZQUFZLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxDQUFDO29CQUMxSCxNQUFNLENBQUMsS0FBSyxDQUFDLE1BQU0sQ0FBQyxVQUFVLEdBQUc7d0JBQzdCLE9BQU8sR0FBRyxLQUFLLE1BQU0sQ0FBQyxHQUFHLENBQUM7b0JBQzlCLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxVQUFVLEdBQUc7d0JBQ3BCLGlCQUFNLENBQUMsVUFBVSxDQUFDLFFBQVEsQ0FBQyxHQUFHLEVBQUUsRUFBQyxDQUFDLEVBQUUsQ0FBQyxFQUFFLENBQUMsRUFBRSxDQUFDLEVBQUMsRUFBRSxVQUFVLEVBQUUsRUFBQyxLQUFLLEVBQUUsT0FBTyxFQUFFLFNBQVMsRUFBRSxDQUFDLEVBQUMsQ0FBQyxDQUFDO29CQUM5RixDQUFDLENBQUMsQ0FBQztpQkFDTjtnQkFFTCxJQUFJLE1BQU0sQ0FBQyxHQUFHLEVBQUU7b0JBQ1osaUJBQU0sQ0FBQyxVQUFVLENBQUMsUUFBUSxDQUFDLE1BQU0sQ0FBQyxHQUFHLEVBQUUsRUFBQyxDQUFDLEVBQUUsQ0FBQyxFQUFFLENBQUMsRUFBRSxDQUFDLEVBQUMsRUFBRSxVQUFVLEVBQUUsRUFBQyxLQUFLLEVBQUUsTUFBTSxFQUFFLFNBQVMsRUFBRSxDQUFDLEVBQUMsQ0FBQyxDQUFDO2lCQUNuRztnQkFFRCxJQUFJLE1BQU0sQ0FBQyxVQUFVLElBQUksTUFBTSxDQUFDLFVBQVUsQ0FBQyxJQUFJLEVBQUU7b0JBQzdDLGlCQUFNLENBQUMsVUFBVSxDQUFDLFFBQVEsQ0FBQyxNQUFNLENBQUMsSUFBSSxFQUFFLEVBQUMsQ0FBQyxFQUFFLEdBQUcsRUFBRSxDQUFDLEVBQUUsR0FBRyxFQUFDLEVBQUUsVUFBVSxFQUFFLEVBQUMsS0FBSyxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsQ0FBQyxFQUFDLENBQUMsQ0FBQztpQkFDdkc7YUFDSjtRQUNILENBQUMsQ0FBQyxDQUFDO0lBSVQsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFBO0lBRU4sT0FBTyxDQUNIO1FBQ0ksOEJBQUMsUUFBUSxJQUFDLEVBQUUsRUFBQyxVQUFVLEdBQVk7UUFFbEMsWUFBWTtZQUNUO2dCQUNJLDJDQUFNLFlBQVksQ0FBQyxTQUFTLENBQU87Z0JBQ25DLDJDQUFNLFlBQVksQ0FBQyxjQUFjLENBQU87Z0JBQ3hDLHlDQUFPLElBQUksRUFBRSxZQUFZLENBQUMsS0FBSyxDQUFDLEtBQUssR0FBVSxDQUM3QyxDQUVYLENBQ04sQ0FBQTtBQUNMLENBQUM7QUFqTEQsMENBaUxDO0FBRUQsSUFBTSxRQUFRLEdBQUcsMkJBQU0sQ0FBQyxHQUFHLHFtQkFBQSw4Y0F3QjFCLElBQUEsQ0FBQSJ9